/* eslint-disable import/prefer-default-export */

import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faHome, //
  faCalendar,
  faCheckCircle,
  faTimesCircle,
  // faRedo,
  // faSignInAlt,
  faFileContract,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import 'bootstrap';
import BootstrapVue from 'bootstrap-vue';
import VueAnalytics from 'vue-analytics';
import VueSweetalert2 from 'vue-sweetalert2';
import VCalendar from 'v-calendar';

import App from './App.vue';
import i18n from './lang/lang';
import router from './router';
import store from './vuex/store';
import './auth';
import './registerServiceWorker';

Vue.use(VCalendar, {
  firstDayOfWeek: 2, // Monday
});

// VFG custom fields
// import fieldVueCalendar from '@/components/playground/vfg/customFields/fieldVueCalendar.vue';
// import fieldVueToggleButton from '@/components/playground/vfg/customFields/fieldVueToggleButton.vue';
// import fieldVueSliderComponent from '@/components/playground/vfg/customFields/fieldVueSliderComponent.vue';

Vue.use(BootstrapVue);
Vue.use(VueSweetalert2);

// VUE-FORM-GENERATOR
let VueFormGenerator = require('vue-form-generator');
// Fix between local and exported project
if (VueFormGenerator.default) {
  VueFormGenerator = VueFormGenerator.default;
}

const {
  fieldCheckbox,
  fieldChecklist,
  fieldInput,
  fieldLabel,
  fieldRadios,
  fieldSelect,
  fieldSubmit,
  fieldTextArea,
  fieldUpload,
  fieldCleave,
  fieldDateTimePicker,
  fieldGoogleAddress,
  fieldImage,
  fieldMasked,
  fieldNoUiSlider,
  fieldPikaday,
  fieldRangeSlider,
  fieldSelectEx,
  fieldSpectrum,
  fieldStaticMap,
  fieldSwitch,
  fieldVueMultiSelect,
} = VueFormGenerator.fieldsLoader;

Vue.use(VueFormGenerator, {
  fields: [
    // custom start
    // fieldVueCalendar,
    // fieldVueToggleButton,
    // fieldVueSliderComponent,
    // custom end
    fieldCheckbox,
    fieldChecklist,
    fieldInput,
    fieldLabel,
    fieldRadios,
    fieldSelect,
    fieldSubmit,
    fieldTextArea,
    fieldUpload,
    fieldCleave,
    fieldDateTimePicker,
    fieldGoogleAddress,
    fieldImage,
    fieldMasked,
    fieldNoUiSlider,
    fieldPikaday,
    fieldRangeSlider,
    fieldSelectEx,
    fieldSpectrum,
    fieldStaticMap,
    fieldSwitch,
    fieldVueMultiSelect,
  ],
});
// VUE-FORM-GENERATOR

library.add(
  faHome, //
  faCalendar,
  faCheckCircle,
  faTimesCircle,
  // faRedo,
  // faSignInAlt,
  faFileContract,
);

Vue.component('FontAwesomeIcon', FontAwesomeIcon);
// Vue.component('vue-headful', () => import('vue-headful'));
// Vue.component('poc-ad', () => import('./components/Ad.vue'));
// Vue.component('debug', () => import('./components/Debug.vue'));
// Vue.component('spinner', () => import('@/components/Spinner'));


Vue.use(VueAnalytics, {
  id: 'UA-xxx',
  router,
  autoTracking: {
    //   page: true,
    //   screenview: false,
    //   exception: true,
    //   pageviewOnLoad: true,
    pageviewTemplate(route) {
      return {
        page: route.path,
        title: document.title,
        location: window.location.href,
      };
    },
  },
// debug: {
//   enabled: !isProd,
//   trace: !isProd,
//   sendHitTask: !isProd,
// },
});

window.Bus = new Vue();

Vue.config.productionTip = false;

export const app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  computed: {
    isAuthenticated() {
      return this.$auth.check();
    },
  },
  watch: {
    isAuthenticated() {
      // window.Echo.connector.pusher.config.auth.headers.Authorization = `Bearer ${this.$auth.token()}`;
      Bus.$emit('updateUserData');
    },
  },
  render: h => h(App),
});
